import appConst from "./appConst.json";
import { image_base_url, tile_base_url } from "./apiUrl";

export const buildBasketItemImageUrl = (item = {}, basket = {}) => {
  const token = sessionStorage.getItem(appConst.TOKEN);
  const product = sessionStorage.getItem(appConst.PRODUCT);

  const fallback = item.itemImageUrl || item.url || "";

  if (!token || !product) {
    return fallback;
  }

  if (
    product === appConst.ORDERS_UNION ||
    product === appConst.BOOKS ||
    product === appConst.CALENDARS
  ) {
    const orderId = basket.order_id || sessionStorage.getItem("order_id");
    const projectTick = item.project_tick;

    if (orderId && projectTick && image_base_url) {
      return `${image_base_url}?order_id=${orderId}&token=${token}&project_tick=${projectTick}`;
    }
    return fallback;
  }

  const projectGuid = item.project_guid;
  const imageName = item.image_name;

  if (projectGuid && imageName && tile_base_url) {
    const type = item.is_paspartu ? "passe-partout" : "no";
    return `${tile_base_url}?token=${token}&image=${imageName}&projectguid=${projectGuid}&type=${type}`;
  }

  return fallback;
};
